import Button from '../../../button/Button';
import { ReactComponent as BusinessIcon } from 'assets/ui-update/business.svg';
import { ReactComponent as IndividualIcon } from 'assets/ui-update/individual.svg';

export type TreeActionButtonsProps = {
    hasControllingParty: boolean;
    hasSubmitted: boolean;
    handleAddOwner(fieldname: string, isBusiness: boolean, bControllingParty: boolean): void;
    fieldname: string;
    isAddingItem: boolean;
    hideAddBusiness?: boolean;
    hideLeftBar?: boolean;
    hasError: boolean;
    percentageFull?: boolean;
};

export const TreeActionButtons: React.FC<TreeActionButtonsProps> = ({
    hasControllingParty,
    hasSubmitted,
    handleAddOwner,
    hideLeftBar = false,
    isAddingItem,
    fieldname,
    hideAddBusiness = false,
    hasError,
    percentageFull = false,
}) => (
    <div className={`TreeActionButtons ${hasError ? 'Error' : ''}`}>
        {hideLeftBar && <div aria-hidden="true" className="FloatingHide Full" />}
        {!hideAddBusiness && (
            <Button
                disabled={isAddingItem || percentageFull}
                type="button"
                priority="secondary"
                onClick={() => handleAddOwner(fieldname, true, false)}
            >
                <BusinessIcon />
                <span>Add business beneficial owner</span>
            </Button>
        )}

        <Button
            disabled={isAddingItem || percentageFull}
            type="button"
            priority="secondary"
            onClick={() => handleAddOwner(fieldname, false, false)}
        >
            <IndividualIcon />
            <span>Add individual beneficial owner</span>
        </Button>

        <Button
            type="button"
            disabled={isAddingItem}
            // Stay neutral until a save attempt has actually failed on this requirement —
            // don't flag it red just because the user hasn't gotten to it yet.
            color={hasControllingParty || !hasSubmitted ? 'second' : 'third'}
            onClick={() => handleAddOwner(fieldname, false, true)}
        >
            <span style={{ textAlign: 'center', width: '100%' }}>
                Add {hasControllingParty && 'additional'} controlling party
            </span>
        </Button>
    </div>
);
